import { QueryClientProvider } from '@tanstack/react-query';

import { appQueryClient } from './appQueryClient';

const AppQueryProvider: FCC = ({ children }) => (
  <QueryClientProvider client={appQueryClient}>{children}</QueryClientProvider>
);

export default AppQueryProvider;
